import React from 'react';
import {Link} from 'react-router';
import {useTranslation} from 'react-i18next';
import examplePortrait from '../../public/examples/600x720/1-v2-320.webp';
import exampleSquare from '../../public/examples/600x600/4-v2-320.webp';
import exampleLandscape from '../../public/examples/600x480/1-v2-320.webp';
import productImage from '../../productImage';

export default function ProductIntro() {
    const {t} = useTranslation();
    return (
        <section className="product-intro" aria-labelledby="product-title">
            <div className="design-container">
                <div className="product-intro-visual" style={{'--product-photo': `url("${productImage.src}")`}} aria-hidden="true">
                    <img className="product-intro-image" src={productImage.src} srcSet={productImage.srcSet} sizes={productImage.sizes} alt="" width="600" height="600" fetchPriority="high" decoding="async"/>
                </div>
                <div className="product-intro-copy">
                    <span className="eyebrow"><span/>{t('design.tagline')}</span>
                    <h1 id="product-title">{t('generator.title')}</h1>
                    <p>{t('generator.subtitle')}</p>
                    <Link to="#examples" className="product-examples-link">
                        <span className="product-example-thumbnails" aria-hidden="true">
                            {[examplePortrait, exampleSquare, exampleLandscape].map(src => <img key={src} src={src} alt="" width="64" height="64" decoding="async"/>)}
                        </span>
                        <span>{t('examples.view')} <span aria-hidden="true">↗</span></span>
                    </Link>
                </div>
            </div>
        </section>
    );
}
